import React from "react";
import { Link } from "react-router-dom";

export default function LegalProfileBox() {
  return (
    <>
      <div className="formProfileBOX text-center">
        <div className="proIMGbox mb-3">
          <img src="../images/blankUser.png" alt="" />
        </div>
        <h5 className="mb-3 fw-600">Googling your legal issue online?</h5>
        <p className="mb-3">
          The internet is not a lawyer and neither are you. Talk to a real
          lawyer about your legal issue.
        </p>
        <Link className="sencondBTNhover">Find my lawer now</Link>
      </div>
    </>
  );
}
